import NavigationMenuMobile from './NavigationMenuMobile.component';
export default NavigationMenuMobile;